module.exports = new __parcel__URL__("snare_2.673c28c6.mp3").toString();